/* hzo-quickadd.js — de koopknop in het snel-toevoegen-blad gelijk aan die op de
 * productpagina.
 *
 * WAAROM DIT BESTAND EERST FOUT WAS. Ik zette hier een eigen `.hzo-qa-prijs` met
 * een middelpunt ertussen. Maar `hzo-pdp.js` doet op de productpagina al precies
 * hetzelfde: het pakt de losse tekst in een `.hzo-atc-label`, hangt daar een
 * pijltje aan met CSS, en zet er een `.hzo-atc-prijs` achter. Twee mechanismen
 * met verschillende opmaak, dus de knop in het blad zag er anders uit dan op de
 * productpagina — en bij een variantwissel wisselde de tekst zichtbaar van vorm.
 * Beide klachten van de eigenaar, één oorzaak.
 *
 * Nu maakt dit bestand DEZELFDE twee elementen, zodat de opmaakregels van de
 * productpagina er zonder uitzondering op passen.
 *
 * WAAROM NIET GEWOON hzo-pdp.js LATEN DRAAIEN. Dat script wordt wél meegekloond
 * naar het blad, maar een `<script>` uit een `DOMParser`-document voert niet uit.
 * Gemeten: in het blad stond alleen mijn eigen opmaak, nooit die van de PDP.
 */
(() => {
  const BLAD = '.quick-add-modal__content';

  function prijsVan(blad) {
    const vak = blad.querySelector('product-price');
    if (!vak) return '';
    /* Bij korting staan er twee bedragen: was en nu. De laatste is wat je
       betaalt. `textContent` en niet `innerText`, want dat laatste is leeg
       zolang het blad nog dicht is. */
    const bedragen = (vak.textContent || '').match(/[^\s]*\d[\d.,]*/g);
    return bedragen && bedragen.length ? bedragen[bedragen.length - 1] : '';
  }

  function allesGekozen(blad) {
    const rijen = blad.querySelectorAll('fieldset.variant-option');
    if (!rijen.length) return true;
    return [...rijen].every((r) => r.querySelector('input:checked'));
  }

  function knopBijwerken() {
    document.querySelectorAll(BLAD).forEach((blad) => {
      blad.querySelectorAll('.add-to-cart-button').forEach((knop) => {
        /* 1 · de losse tekst inpakken, net als op de productpagina, zodat het
              pijltje er met CSS aan kan hangen */
        if (!knop.querySelector('.hzo-atc-label')) {
          const tekstknoop = [...knop.childNodes].find(
            (n) => n.nodeType === Node.TEXT_NODE && n.textContent.trim()
          );
          if (tekstknoop) {
            const omhulsel = document.createElement('span');
            omhulsel.className = 'hzo-atc-label';
            omhulsel.textContent = tekstknoop.textContent.trim();
            tekstknoop.replaceWith(omhulsel);
          }
        }

        if (!allesGekozen(blad)) {
          knop.dataset.hzoKies = 'true';
          return;
        }
        delete knop.dataset.hzoKies;

        const bedrag = prijsVan(blad);
        if (!bedrag) return;

        let prijs = knop.querySelector('.hzo-atc-prijs');
        if (!prijs) {
          prijs = document.createElement('span');
          prijs.className = 'hzo-atc-prijs';
          prijs.setAttribute('aria-hidden', 'true');
          knop.appendChild(prijs);
        }
        if (prijs.textContent !== bedrag) prijs.textContent = bedrag;

        /* de prijs hoort altijd achteraan, ook nadat Horizon de knop hertekent */
        if (knop.lastElementChild !== prijs) knop.appendChild(prijs);
      });
    });
  }

  /* Bij het openen, bij elke variantwissel, en als Horizon het blad hertekent.
   *
   * EEN LADDER, GEEN ENKELE POGING. Hier stond één `setTimeout(…, 60)`. Horizon
   * hertekent na een maatwissel de hele knop, en of dat binnen 60 ms klaar is
   * hangt af van de verbinding. Was het niet klaar, dan zette onze code de prijs
   * op de oude knop en gooide Horizon hem daarna weg: de knop viel terug op
   * "ADD TO CART" zonder bedrag, en bleef zo tot je het venster sloot.
   * De productpagina probeert het al langer op vier momenten; dat doen we hier nu
   * ook. Vier keer hetzelfde neerzetten is gratis, want `knopBijwerken` schrijft
   * alleen als de tekst afwijkt. */
  const LADDER = [60, 200, 500, 900];
  const opnieuw = () => LADDER.forEach((ms) => setTimeout(knopBijwerken, ms));

  /* MAAR DE LADDER ALLEEN IS NIET GENOEG — dezelfde klacht als op de productpagina.
     Tussen het moment waarop Horizon de knop vervangt en de eerstvolgende trede
     staat de knop kaal: "ADD TO CART" zonder bedrag. Gemeten op de productpagina
     met een waarnemer op de knoptekst: $-bedrag, geen bedrag, $-bedrag.

     Deze waarnemer herstelt het binnen één beeldje. Hij grijpt alleen in als er
     echt iets ontbreekt, en staat tijdens ons eigen schrijven los — anders roept
     hij zichzelf aan. */
  let bladWaarnemer = null;

  function bladIetsOntbreekt() {
    const knoppen = [...document.querySelectorAll(BLAD + ' .add-to-cart-button')];
    if (!knoppen.length) return false;
    return knoppen.some((k) => {
      if (!k.querySelector('.hzo-atc-label')) return true;
      /* Zolang niet alles gekozen is hoort er geen bedrag te staan; dan is een
         knop zonder prijs juist goed en moeten we níet ingrijpen. */
      const blad = k.closest(BLAD);
      if (blad && !allesGekozen(blad)) return false;
      return !k.querySelector('.hzo-atc-prijs');
    });
  }

  function bladBewaken() {
    const blad = document.querySelector('.quick-add-modal');
    if (!blad || bladWaarnemer) return;
    bladWaarnemer = new MutationObserver(() => {
      if (!bladIetsOntbreekt()) return;
      bladWaarnemer.disconnect();
      knopBijwerken();
      bladWaarnemer.observe(blad, { childList: true, subtree: true });
    });
    bladWaarnemer.observe(blad, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bladBewaken, { once: true });
  } else {
    bladBewaken();
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest?.('.quick-add, ' + BLAD)) opnieuw();
  });
  document.addEventListener('change', (e) => {
    if (e.target.closest?.(BLAD)) opnieuw();
  });
  document.addEventListener('toggle', (e) => {
    if (e.target instanceof Element && e.target.classList?.contains('quick-add-modal')) {
      setTimeout(knopBijwerken, 120);
      setTimeout(knopBijwerken, 600);
    }
  }, true);

  /* ── waarom het blad traag opengaat, en wat we eraan doen ──────────────────
   *
   * GEMETEN op 13 aug 2026, op de collectiepagina van The Hills. Eén klik op de
   * plusknop trekt de HELE productpagina binnen: drie verzoeken naar dat product
   * (69 kB, 629 ms en 733 ms) en daarna nog veertien voor de stylesheets, scripts
   * en lettertypes die in die pagina staan. Samen 17 verzoeken en 167 kB voordat
   * er iets te zien is.
   *
   * Horizon bewaart het resultaat wel (`#cachedContent`), maar pas NA de eerste
   * klik. De eerste keer per product wacht je dus. Dat is precies de klacht van
   * de eigenaar: "die quick add moet ik soms een paar keer indrukken".
   *
   * Twee dingen hieronder, en ze werken los van elkaar:
   *
   * 1. VOORVERWARMEN. Zodra de muis of vinger de knop raakt, halen we dezelfde
   *    pagina alvast op. Tegen de tijd dat de klik komt staat hij in de cache van
   *    de browser en hoeft Horizons eigen `fetch` hem niet meer over de lijn te
   *    halen. Dezelfde URL als Horizon gebruikt — via zijn eigen `productPageUrl`
   *    en niet zelf samengesteld, anders is het een andere cache-sleutel en heeft
   *    het geen enkel nut.
   *
   * 2. METEEN LATEN ZIEN DAT DE KLIK AANKWAM. Dit is wat het herhaald indrukken
   *    stopt, ook als het netwerk traag blijft: zonder terugkoppeling denk je dat
   *    er niets gebeurde. De knop krijgt `data-hzo-bezig` en het stylesheet maakt
   *    daar een wachttoestand van.
   */
  const voorgewarmd = new Set();

  function voorwarmen(knop) {
    const comp = knop.closest('quick-add-component');
    const adres = comp && comp.productPageUrl;
    if (!adres || voorgewarmd.has(adres)) return;
    voorgewarmd.add(adres);
    /* Stil falen is hier de bedoeling: dit is een extraatje. Gaat het mis, dan
       doet Horizon precies wat hij eerst ook deed. */
    try {
      fetch(adres, { credentials: 'same-origin' }).catch(() => {});
    } catch (e) {
      /* een browser zonder fetch komt hier niet, maar breken mag het nooit */
    }
  }

  const raak = (e) => {
    const knop = e.target.closest?.('.quick-add__button');
    if (knop) voorwarmen(knop);
  };
  document.addEventListener('pointerover', raak, { passive: true });
  document.addEventListener('touchstart', raak, { passive: true });
  document.addEventListener('focusin', raak);

  document.addEventListener(
    'click',
    (e) => {
      const knop = e.target.closest?.('.quick-add__button');
      if (!knop) return;
      voorwarmen(knop);
      knop.dataset.hzoBezig = 'true';
      /* Vangnet: gaat het blad door wat voor reden dan ook niet open, dan mag de
         knop niet voor altijd in de wachtstand blijven staan. */
      clearTimeout(knop.__hzoVangnet);
      knop.__hzoVangnet = setTimeout(() => delete knop.dataset.hzoBezig, 8000);
    },
    true
  );

  /* De wachttoestand hoort weg zodra het blad er is — en ook als het misgaat,
     anders blijft de knop voor altijd in de wachtstand staan. */
  function bezigWeg() {
    document.querySelectorAll('.quick-add__button[data-hzo-bezig]').forEach((k) => {
      delete k.dataset.hzoBezig;
    });
  }
  document.addEventListener('toggle', bezigWeg, true);
  new MutationObserver(() => {
    if (document.querySelector('.quick-add-modal[open]')) bezigWeg();
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });
})();
